import React from "react";

import DangerIcon from "../../assets/icons/danger.svg";

import "./styles.scss";

const ErrorText = ({ error }: { error: string }): JSX.Element => (
  <div className="error d-flex">
    <img src={DangerIcon} alt={error} />
    {error}
  </div>
);

export default ErrorText;
